export const enum CartTopBannerEventName {
  Click = 'home-club-banner_click',
  View = 'home-club-banner_view',
}
